import angular from 'angular';

import BRANDS_EVENTS from './constants/brandsEvents.constant';
import brandsContainer from './containers/brands.container';
import brandsAdminSettingsModalContainer from './containers/brandsAdminSettingsModal.container';
import brandsUsersListContainer from './containers/brandsUsersList.container';
import brandsListContainer from './containers/brandsList.container';
import brandsPermissionsModalContainer from './containers/brandsPermissionsModal.container';
import brandsRevokeModalContainer from './containers/brandsRevokeModal.container';
import brands from './components/brands/brands.component';
import brandsAdminSettingsForm from
  './components/brandsAdminSettingsForm/brandsAdminSettingsForm.component';
import brandsUsers from './components/brandsUsers/brandsUsers.component';
import routeProviderConfig from './configs/routeProvider.config';

const brandsModule = angular.module('brands', [])
.constant('BRANDS_EVENTS', BRANDS_EVENTS)
.component('brandsContainer', brandsContainer)
.component('brandsAdminSettingsModalContainer', brandsAdminSettingsModalContainer)
.component('brandsUsersListContainer', brandsUsersListContainer)
.component('brandsListContainer', brandsListContainer)
.component('brandsPermissionsModalContainer', brandsPermissionsModalContainer)
.component('brandsRevokeModalContainer', brandsRevokeModalContainer)
.component('brands', brands)
.component('brandsAdminSettingsForm', brandsAdminSettingsForm)
.component('brandsUsers', brandsUsers)
.config(routeProviderConfig);


export default brandsModule.name;
